/**
 * ダイヤモンド（4軸レーダー）の座標計算。
 *
 * 組織レポートの組織ダイヤモンドと、個人レポートの本人ダイヤモンドで共有する。
 * どちらも「A左上・D右上・C右下・B左下」の同じ配置なので、置き方をここで1つに保つ。
 */
import type { AxisKey } from './gb74Report';

/** 各軸の角度（度）。A左上・D右上・C右下・B左下。 */
export const DIAMOND_DEG: Record<AxisKey, number> = { A: 135, D: 45, C: 315, B: 225 };

/** 描画順（時計回り）。ポリゴンの頂点はこの順に並べる。 */
export const DIAMOND_ORDER: AxisKey[] = ['A', 'D', 'C', 'B'];

/** 軸ラベル（基本方針: A論理 / B着実 / C共感 / D創造）。 */
export const DIAMOND_AXIS_LABEL: Record<AxisKey, string> = {
  A: 'A 論理',
  B: 'B 着実',
  C: 'C 共感',
  D: 'D 創造',
};

/**
 * 円を <path> で描く。
 * <circle> の cx/cy/r はPDF化のキャプチャ経路で上書きされることがあるため使わない。
 */
export function circlePath(cx: number, cy: number, r: number): string {
  return `M ${cx - r},${cy} a ${r},${r} 0 1,0 ${r * 2},0 a ${r},${r} 0 1,0 ${-r * 2},0`;
}

/** 中心からの極座標をSVG座標に変換する。 */
export function polar(deg: number, r: number, c: number): [number, number] {
  const rad = (deg * Math.PI) / 180;
  return [c + r * Math.cos(rad), c - r * Math.sin(rad)];
}
